import * as React from "react";
import Logo from "../../assets/logo/1800AccountantLogo.svg";
import { Container } from "@mui/material";
import SuccessIcon from "../../assets/icons-svg/success-icon.svg";
import { useAppState } from "../../provider/AppProvider";
export default function InfoSubmitted() {

  const { logo } = useAppState()

  return (
    <Container maxWidth={false} className="info-submitted">
      <div className="header">
        <div className="header--container">
          <div className="header--content">
            <img src={logo} alt="1800-Accountant logo"></img>
          </div>
        </div>
      </div>

      <div className="info-submitted__wrapper">
        <div className="info-submitted__content">
          <img
            src={SuccessIcon}
            alt="Success"
            className="info-submitted__success"
          ></img>
          <h1>Your information was successfully submitted to your employer</h1>
          <p>
            You’ll need to contact your employer if you need to make any
            additional adjustments to your information.
          </p>
        </div>
      </div>
    </Container>
  );
}
